export const Triangle = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="8"
			height="9"
			viewBox="0 0 8 9"
			fill="none"
		>
			<path
				d="M7.61035 8.02573V0.371094C7.61035 0.371094 0.522721 3.02078 0.522721 4.10028C0.522721 5.17978 7.61035 8.02573 7.61035 8.02573Z"
				fill="#7A3F1E"
			/>
			<path
				d="M7.89453 7.45812V0.9375C7.89453 0.9375 1.37391 3.19464 1.37391 4.11421C1.37391 5.03379 7.89453 7.45812 7.89453 7.45812Z"
				fill="#FFFAF1"
			/>
		</svg>
	);
};
